import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

import { useData } from '@/components/data-provider';
import { useOfflineSync } from '@/hooks/use-offline-sync';

export const OfflineBanner = () => {
	const { isOnline } = useData();
	const { pendingCount, isSyncing } = useOfflineSync();

	// Show syncing banner briefly when coming back online with pending items
	if (isOnline && isSyncing) {
		return (
			<View style={styles.syncingContainer} testID="syncing-indicator">
				<Text style={styles.text} testID="syncing-message">
					Syncing {pendingCount} pending item{pendingCount !== 1 ? 's' : ''}...
				</Text>
			</View>
		);
	}

	if (isOnline) {
		return null;
	}

	return (
		<View style={styles.container} testID="offline-indicator">
			<Text style={styles.text} testID="offline-message">
				You are currently offline.
				{pendingCount > 0
					? ` ${pendingCount} item${pendingCount !== 1 ? 's' : ''} queued for sync.`
					: ''}
			</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		backgroundColor: '#ff0000',
		padding: 10,
		alignItems: 'center',
		justifyContent: 'center',
	},
	syncingContainer: {
		backgroundColor: '#2196F3',
		padding: 10,
		alignItems: 'center',
		justifyContent: 'center',
	},
	text: {
		color: '#ffffff',
	},
});
